import React from 'react';
import Home from './scenes/home/Home';

function App() {
  return (
    <div className="App container-fluid">       
       <h1 className="display-5 fw-semibold">OpenAI Token Probability Visualizer</h1>       
      <Home />
    </div>
  );
}

export default App;
